import moment from "moment";

export const DateTimeDisplay = ({
  startDateTime,
  endDateTime,
}: {
  startDateTime: any;
  endDateTime: any;
}) => {
  const formatISODate = (isoString: any) => {
    const date = new Date(isoString);

    let hours = date.getUTCHours();
    const minutes = date.getUTCMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    // Convert hours from 24-hour format to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    return `${hours}:${minutes} ${ampm}`;
  };

  const formatDate = (isoString: any) => {
    const date = new Date(isoString);

    // Extract day, month, and year
    const day = date.getUTCDate();
    const month = date.toLocaleString("en-US", { month: "short" }); // e.g., "Aug"
    const year = date.getUTCFullYear().toString().slice(-2); // Get last 2 digits of the year

    // Format date as "DD MMM, YY"
    return `${day.toString().padStart(2, "0")} ${month}, ${year}`;
  };

  return (
    <span className="s-date">
      <span className="e-date">
        {startDateTime && formatISODate(startDateTime)} -{" "}
        {endDateTime && formatISODate(endDateTime)}
      </span>
      {" - "}
      {formatDate(startDateTime)}
    </span>
  );
};
